import { Box, Button, Typography, useTheme } from '@mui/material';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Page } from '@/components/Layout/Page/Page';
import { ContentContainer } from '@/components/Layout/Page/Page.styled';

import { ROUTE } from '@/constants/routes';

import { useResponsive } from '@/hooks/useResponsive';
import { useTranslate } from '@/hooks/useTranslate';

import { getDataTestId } from '@/utils/browser';

export default function PreApprovedStatusPage() {
  const { t } = useTranslate();
  const theme = useTheme();
  const navigate = useNavigate();
  const onBackToLogin = () => {
    navigate(ROUTE.HOME);
  };
  const { isMobile } = useResponsive();

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'medium',
      }}
      hasLogo
    >
      <ContentContainer>
        <Typography variant="headlineH2">
          <Trans
            i18nKey="createNewAccount.preApprovedStatus.title"
            components={{
              a1: (
                <Typography
                  variant="headlineH2"
                  component="span"
                  color={theme.palette.primaries[500]}
                />
              ),
            }}
          />
        </Typography>
        <Typography variant="bodyB2Regular">
          <Trans i18nKey="createNewAccount.preApprovedStatus.message" />
        </Typography>
      </ContentContainer>
      <Box width="100%">
        <Button
          {...getDataTestId(`page-action-back-to-login`)}
          onClick={onBackToLogin}
          variant={isMobile ? 'contained' : 'text'}
          sx={{ width: isMobile ? '100%' : 'auto' }}
        >
          {t('layout.page.button.backToLogin')}
        </Button>
      </Box>
    </Page>
  );
}
